<div *ngIf="showModelNow" class="modal-content-root" tabindex="-1" role="dialog">
  <div class="modal-backdrop fade show"></div>
  <div class="modal-dialog modal-dialog-centered" style="z-index: 1200;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <span *ngIf="stepNumber === 1" style="padding-left:15px;">Please review your Design and Visalisation
            files</span>
          <span *ngIf="stepNumber === 2">
            <button (click)="changeStep(1)" (click)="feedbackId = ''" class="btn">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.3345 6.98965L16.5066 6.98964L16.5066 8.98934L4.33521 8.99006L9.69861 14.3535L8.28439 15.7677L0.506225 7.9895L8.2844 0.211327L9.69861 1.62554L4.3345 6.98965Z"
                  fill="black" />
              </svg>
            </button>
            Rate your order</span>
          <span *ngIf="stepNumber === 3">

            <button (click)="changeStep(1)" (click)="feedbackId = ''" class="btn">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.3345 6.98965L16.5066 6.98964L16.5066 8.98934L4.33521 8.99006L9.69861 14.3535L8.28439 15.7677L0.506225 7.9895L8.2844 0.211327L9.69861 1.62554L4.3345 6.98965Z"
                  fill="black" />
              </svg>
            </button>
            Request
            correction</span>
          <span *ngIf="stepNumber === 4">
            <button (click)="changeStep(1)" (click)="feedbackId = ''" class="btn">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.3345 6.98965L16.5066 6.98964L16.5066 8.98934L4.33521 8.99006L9.69861 14.3535L8.28439 15.7677L0.506225 7.9895L8.2844 0.211327L9.69861 1.62554L4.3345 6.98965Z"
                  fill="black" />
              </svg>
            </button>
            Cancel order
          </span>

        </h5>
        <button  style="position: absolute; right: 11px"  type="button" class="btn-close" aria-label="Close" (click)="closeModal(false)"
          (click)="changeStep(1)" (click)="feedbackId = ''"></button>
      </div>
      <div class="modal-body" style="padding: 24px;">


        <!-- step 3: Request Correction -->
          <div *ngIf="stepNumber === 3" class="d-flex flex-column gap-2">
            <div>
              <span style="color: #707070;font-size: 14px;font-weight: 400;">You have
                {{orderDetailsNew.remainingCorrections}} revisions left.</span>
              <div class="d-flex align-content-start justify-content-start" style="gap:12px; margin-top: 5px;">
                <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
                <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
                <div style="background:#FAF9F9;position: relative; padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <svg width="15" height="64" viewBox="0 0 15 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style="position: absolute;left:50%;top:0;transform:translateX(-50%)">
                    <path
                      d="M6.99951 -8.75586L2.99951 1.72685L8.49951 8.50977L4.99951 15.2927L9.49951 22.6923L2.99951 33.7916L11.9995 49.2073L6.99951 57.8402L9.49951 64.6231L4.99951 73.2559"
                      stroke="white" stroke-width="5" />
                  </svg>

                </div>

              </div>
            </div>
            <div class="d-flex flex-column gap-2">
              <span style="font-weight: 500;font-size: 16px;">Please provide feedback for the designer:</span>
              <textarea id="" [(ngModel)]="feedbackText" name="feedback"
                style="border: 1px solid #E4E4E4;padding: 16px;border-radius: 8px;outline:none;"></textarea>
            </div>

            <div class="d-flex flex-column gap-2">
              <p class="m-0" style="font-weight: 500;font-size: 16px;">Attach Files:</p>
              <div class="files-wrap d-flex flex-wrap align-items-start gap-2">
                <div class="drag-drop-area w-100" (click)="scanFile.click()">
                  <div class="upload-icon"><!-- your svg … --></div>
                  <p class="drag-drop-text">
                    Drag & Drop or <a href="javascript:void(0)" class="choose-file-link">Choose file</a> to upload
                  </p>
                  <p class="allowed-file-types m-0">PDF, GLB, STEP</p>

                  <input hidden multiple (change)="addFileDetails($event)" #scanFile type="file" id="scanFile"
                    accept=".pdf,.png,.jpg,.jpeg,.stl,.zip" />
                </div>
                <div class="files-stack">
                  <ng-container *ngFor="let p of (progress | keyvalue)">
                    <div class="upload-card">
                      <!-- top row: name + close -->
                      <div class="row-1">
                        <div class="file-name text-truncate" [title]="p.key">{{ p.key }}</div>
                        <button type="button" class="icon-btn" (click)="removeFileByName(p.key); removeProgress(p.key)"
                          aria-label="Remove file">×</button>
                      </div>

                      <!-- second row: size • eta (when uploading) -->
                      <div class="row-2">
                        <span class="muted">{{ p.value.sizeLabel }}</span>
                        <span class="dot" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">•</span>
                        <span class="muted" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">
                          {{ p.value.etaLabel || 'calculating…' }}
                        </span>
                        <span class="muted" *ngIf="p.value.state === 'done'">Completed</span>
                        <span class="muted error" *ngIf="p.value.state === 'error'">Failed</span>

                        <span class="percent" *ngIf="p.value.state !== 'error'">
                          {{ p.value.percent }}%
                        </span>
                      </div>

                      <!-- progress bar -->
                      <div class="bar-wrap" *ngIf="p.value.state !== 'error'">
                        <div class="bar-track">
                          <div class="bar-fill" [style.width.%]="p.value.percent"></div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

              </div>
            </div>
<!-- manisha -->
            <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
              <div  *ngIf="ShowRequestFeedback" style="color: #065c0b; font-weight: 500; font-size: 20px;text-align: center;">
                {{feedbackMessageRequest}}
              </div>

             <button
    class="w-100 request-btn"
    [disabled]="isRequestCorrection"
    [ngClass]="{ 'btn-disabled': isRequestCorrection }"
    (click)="requestCorrection(taskId)">
    Request correction
  </button>
            </div>
          </div>

        <!-- step 1: Main Page -->
        <div *ngIf="stepNumber === 1" class="d-flex flex-column gap-2">

          <!-- step 1: Review your files -->
          <!-- step 1: Review your files -->
          <!-- loop here -->

         
          <ng-container *ngFor="let file of fileDetailsVisual; let isFirst = first">

            <!-- label only once -->
            <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
              [style.color]="file.fileType === 'visual' ? '#6F6F6F ' : '#8B5E3C'">
              {{ file.fileType === 'visual' ? '3D Visualisation Files :' : file.fileType }}
            </h6>

            <!-- file row -->
            <div class="d-flex align-items-center rounded"
              style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

              <div class="d-flex flex-column gap-1 align-items-start">
                <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                  {{ file.fileName }}
                </span>
                <span>{{ file.fileSize }}</span>
              </div>

              <div class="d-flex align-items-center justify-content-start w-100">
                <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                  DOWNLOADING
                </div>
                <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                  COMPLETE
                </div>
                <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                  ERROR
                </div>
              </div>

              <div *ngIf="checkCondition(file.fileId, 0)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                class="d-flex align-items-center justify-content-center">
                <button
                  style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
              </div>

              <div *ngIf="checkCondition(file.fileId,  2)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                  <path
                    d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                    fill="white" />
                </svg>
              </div>

              <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

            </div>
          </ng-container>

           <ng-container *ngFor="let file of fileDetailsDesign; let isFirst = first">

            <!-- label only once -->
            <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
              [style.color]="file.fileType === 'design' ? '#6F6F6F ' : '#8B5E3C'">
              {{ file.fileType === 'design' ? 'Design Files :' : file.fileType }}
            </h6>

            <!-- file row -->
            <div class="d-flex align-items-center rounded"
              style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

              <div class="d-flex flex-column gap-1 align-items-start">
                <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                  {{ file.fileName }}
                </span>
                <span>{{ file.fileSize }}</span>
              </div>

              <div class="d-flex align-items-center justify-content-start w-100">
                <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                  DOWNLOADING
                </div>
                <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                  COMPLETE
                </div>
                <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                  ERROR
                </div>
              </div>

              <div *ngIf="checkCondition(file.fileId, 0)" class="d-flex align-items-center justify-content-center"
                [style.opacity]="isApproved() ? 1 : 0.4" [style.pointerEvents]="isApproved() ? 'auto' : 'none'"
                (click)="(isApproved()) && downloadFile(file.fileId, file.fileName)">
                <ng-container *ngIf="isApproved(); else lockedIcon">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>

                </ng-container>
                <ng-template #lockedIcon>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 10V7a6 6 0 1 1 12 0v3" stroke="#4B4B4B" stroke-width="2" stroke-linecap="round" />
                    <rect x="4" y="10" width="16" height="12" rx="2" fill="#B0B0B0" stroke="#4B4B4B" stroke-width="2" />
                    <circle cx="12" cy="16" r="1.5" fill="#4B4B4B" />
                  </svg>
                </ng-template>
              </div>

              <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                class="d-flex align-items-center justify-content-center">
                <button
                  style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
              </div>

              <div *ngIf="checkCondition(file.fileId,  2)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                  <path
                    d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                    fill="white" />
                </svg>
              </div>


              <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <div *ngIf="checkCondition(file.fileId, 3) " class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

            </div>
          </ng-container>

          <!-- Design Files Loop -->
          <ng-container *ngFor="let file of fileDetailsCorrected3dVisualisation; let isFirst = first">

            <!-- label only once -->
            <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
              [style.color]="file.fileType === 'correctedvisual' ? '#6F6F6F ' : '#8B5E3C'">
              {{ file.fileType === 'correctedvisual' ? 'Corrected 3D Visualisation Files :' : file.fileType }}
            </h6>

            <!-- file row -->
            <div class="d-flex align-items-center rounded"
              style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

              <div class="d-flex flex-column gap-1 align-items-start">
                <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                  {{ file.fileName }}
                </span>
                <span>{{ file.fileSize }}</span>
              </div>

              <div class="d-flex align-items-center justify-content-start w-100">
                <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                  DOWNLOADING
                </div>
                <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                  COMPLETE
                </div>
                <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                  ERROR
                </div>
              </div>
              <div *ngIf="checkCondition(file.fileId,  0)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                class="d-flex align-items-center justify-content-center">
                <button
                  style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
              </div>

              <div *ngIf="checkCondition(file.fileId, 2)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                  <path
                    d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                    fill="white" />
                </svg>
              </div>

              <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </ng-container>
          <!-- Design Files Loop -->
          <ng-container *ngFor="let file of fileDetailsCorrectedDesign; let isFirst = first">

            <!-- label only once -->
            <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
              [style.color]="file.fileType === 'correcteddesign' ? '#6F6F6F ' : '#8B5E3C'">
              {{ file.fileType === 'correcteddesign' ? 'Corrected Design Files :' : file.fileType }}
            </h6>

            <!-- file row -->
            <div class="d-flex align-items-center rounded"
              style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

              <div class="d-flex flex-column gap-1 align-items-start">
                <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                  {{ file.fileName }}
                </span>
                <span>{{ file.fileSize }}</span>
              </div>

              <div class="d-flex align-items-center justify-content-start w-100">
                <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                  DOWNLOADING
                </div>
                <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                  COMPLETE
                </div>
                <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                  style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                  ERROR
                </div>
              </div>
              <div *ngIf="checkCondition(file.fileId, 0)" class="d-flex align-items-center justify-content-center"
                [style.opacity]="(isApproved() || !hasCorrected3d()) ? 1 : 0.4"
                [style.pointerEvents]="(isApproved() || !hasCorrected3d()) ? 'auto' : 'none'"
                (click)="(isApproved() || !hasCorrected3d()) && downloadFile(file.fileId, file.fileName)">
                <ng-container *ngIf="(isApproved() || !hasCorrected3d()); else lockedIcon">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>

                </ng-container>
                <ng-template #lockedIcon>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 10V7a6 6 0 1 1 12 0v3" stroke="#4B4B4B" stroke-width="2" stroke-linecap="round" />
                    <rect x="4" y="10" width="16" height="12" rx="2" fill="#B0B0B0" stroke="#4B4B4B" stroke-width="2" />
                    <circle cx="12" cy="16" r="1.5" fill="#4B4B4B" />
                  </svg>
                </ng-template>
              </div>

              <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                class="d-flex align-items-center justify-content-center">
                <button
                  style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
              </div>

              <div *ngIf="checkCondition(file.fileId, 2)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                  <path
                    d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                    fill="white" />
                </svg>
              </div>

              <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                (click)="downloadFile(file.fileId, file.fileName)">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1951_2172)">
                    <path
                      d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                      fill="black" />
                    <path
                      d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1951_2172">
                      <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </ng-container>
          <!-- loop end -->

          <div class="w-100 d-flex justify-content-center" style="margin-top: 80px;">
            <p style="font-weight: 400;font-size: 14px;color: #707070;text-align: center;width: 332px;">The order did
              not go according to your wishes and the results are not satisfactory? <a style="cursor: pointer;"
                (click)="changeStep(4)" (click)="feedbackId = '1'">Cancel Order</a></p>
          </div>
          <div class="d-flex gap-2 justify-content-center">
            <!-- Buttons only when NOT approved -->
            <div *ngIf="!isApproved()" class="d-flex gap-2 justify-content-center">
<!-- Buttons only when NOT approved -->
<div *ngIf="!isApproved()" class="d-flex gap-2 justify-content-center">

  <button
    (click)="changeStep(3); feedbackId = '2'"
    [disabled]="isRequestCorrection"
    [class.disabled-btn]="isRequestCorrection"
    style="
      border-radius: 8px;
      border:1.5px solid #E4E4E4;
      font-size: 13px;
      font-weight: 500;
      padding: 14px 35px;
      min-width: 180px;
    ">
    Request correction
  </button>

  <button
    (click)="onApprove()"
    [disabled]="isRequestCorrection"
    [class.disabled-btn]="isRequestCorrection"
    style="
      background: #5ECDA7;
      border-radius: 8px;
      border:1.5px solid #E4E4E4;
      font-size: 13px;
      font-weight: 500;
      padding: 14px 35px;
      min-width: 180px;
    ">
    Approve
  </button>

</div>

            </div>


  <div *ngIf="!showButtons && showFeedbackMessage" style="color: #065c0b; font-weight: 500; font-size: 20px;">
    {{ feedbackMessage }}
  </div>


          </div>

          <!-- step 2: Provide feedback -->
          <div *ngIf="stepNumber === 2" class="d-flex flex-column gap-2">
            <div>
              <span style="color: #707070;font-size: 14px;font-weight: 400;">Help us to improve our platform with your
                review.</span>
            </div>
            <div class="star-rating">
              <span *ngFor="let star of stars; let i = index" (click)="rate(i + 1)" (mouseenter)="hover(i + 1)"
                (mouseleave)="hover(0)" class="star" [class.filled]="(hoveredRating || rating) > i">
                ★
              </span>
            </div>
            <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
              <button class="w-100"
                style="text-decoration: underline;font-weight: 400;font-size: 14px;background: none;border:none;outline:none;">Skip</button>
              <button class="w-100" (click)="cancelOrder()"
                style="background: #5ECDA7;padding: 12px 16px;border-radius: 8px;border: none;font-size: 14px;outline: none;font-weight: 500;">Send</button>
            </div>
          </div>


          <!-- step 3: Request Correction -->
          <div *ngIf="stepNumber === 3" class="d-flex flex-column gap-2">
            <div>
              <span style="color: #707070;font-size: 14px;font-weight: 400;">You have
                {{orderDetailsNew.remainingCorrections}} revisions left.</span>
              <div class="d-flex align-content-start justify-content-start" style="gap:12px; margin-top: 5px;">
                <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
                <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
                <div style="background:#FAF9F9;position: relative; padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <svg width="15" height="64" viewBox="0 0 15 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style="position: absolute;left:50%;top:0;transform:translateX(-50%)">
                    <path
                      d="M6.99951 -8.75586L2.99951 1.72685L8.49951 8.50977L4.99951 15.2927L9.49951 22.6923L2.99951 33.7916L11.9995 49.2073L6.99951 57.8402L9.49951 64.6231L4.99951 73.2559"
                      stroke="white" stroke-width="5" />
                  </svg>

                </div>

              </div>
            </div>
            <div class="d-flex flex-column gap-2">
              <span style="font-weight: 500;font-size: 16px;">Please provide feedback for the designer:</span>
              <textarea id="" [(ngModel)]="feedbackText" name="feedback"
                style="border: 1px solid #E4E4E4;padding: 16px;border-radius: 8px;outline:none;"></textarea>
            </div>

            <div class="d-flex flex-column gap-2">
              <p class="m-0" style="font-weight: 500;font-size: 16px;">Attach Files:</p>
              <div class="files-wrap d-flex flex-wrap align-items-start gap-2">
                <div class="drag-drop-area w-100" (click)="scanFile.click()">
                  <div class="upload-icon"><!-- your svg … --></div>
                  <p class="drag-drop-text">
                    Drag & Drop or <a href="javascript:void(0)" class="choose-file-link">Choose file</a> to upload
                  </p>
                  <p class="allowed-file-types m-0">PDF, GLB, STEP</p>

                  <input hidden multiple (change)="addFileDetails($event)" #scanFile type="file" id="scanFile"
                    accept=".pdf,.png,.jpg,.jpeg,.stl,.zip" />
                </div>
                <div class="files-stack">
                  <ng-container *ngFor="let p of (progress | keyvalue)">
                    <div class="upload-card">
                      <!-- top row: name + close -->
                      <div class="row-1">
                        <div class="file-name text-truncate" [title]="p.key">{{ p.key }}</div>
                        <button type="button" class="icon-btn" (click)="removeFileByName(p.key); removeProgress(p.key)"
                          aria-label="Remove file">×</button>
                      </div>

                      <!-- second row: size • eta (when uploading) -->
                      <div class="row-2">
                        <span class="muted">{{ p.value.sizeLabel }}</span>
                        <span class="dot" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">•</span>
                        <span class="muted" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">
                          {{ p.value.etaLabel || 'calculating…' }}
                        </span>
                        <span class="muted" *ngIf="p.value.state === 'done'">Completed</span>
                        <span class="muted error" *ngIf="p.value.state === 'error'">Failed</span>

                        <span class="percent" *ngIf="p.value.state !== 'error'">
                          {{ p.value.percent }}%
                        </span>
                      </div>

                      <!-- progress bar -->
                      <div class="bar-wrap" *ngIf="p.value.state !== 'error'">
                        <div class="bar-track">
                          <div class="bar-fill" [style.width.%]="p.value.percent"></div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

              </div>
            </div>
            

            <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
              <button class="w-100"
                style="background: #5ECDA7;padding: 12px 16px;border-radius: 8px;border: none;font-size: 14px;outline: none;font-weight: 500;"
                (click)="requestCorrection(taskId)">Request
                correction</button>
            </div>
          </div>


          <!-- step 4: Cancel Order -->
          <div *ngIf="stepNumber === 4" class="d-flex flex-column gap-2">

            <div class="d-flex flex-column gap-2">
              <span style="font-weight: 500;font-size: 16px;">Please tell us in as much detail as
                possible why you would like to cancel this order:</span>
              <textarea name="" id="" [(ngModel)]="cancelReason"
                style="border: 1px solid #E4E4E4;padding: 16px;border-radius: 8px;outline:none;"></textarea>
            </div>

            <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
              <button class="w-100"
                style="text-decoration: underline;font-weight: 400;font-size: 14px;background: none;border:none;outline:none;">Skip</button>
              <button class="w-100" (click)="cancelOrder()"
                style="background: #5ECDA7;padding: 12px 16px;border-radius: 8px;border: none;font-size: 14px;outline: none;font-weight: 500;">Send</button>
            </div>


          </div>


        </div>
      </div>
    </div>


  </div>
  


  <!-- Review Overlay -->
  <div *ngIf="showReviewOverlay" class="review-backdrop">
    <div class="review-modal">
       <div *ngIf="showFeedbackMessage" class="review-success-msg">
      {{ feedbackMessage }}
    </div>
      <!-- step 2: Provide feedback -->
      <div class="d-flex flex-column gap-2">
        <div>
          <span style="color: #707070;font-size: 14px;font-weight: 400;">
            Help us to improve our platform with your review.
          </span>
        </div>

        <div class="star-rating">
          <span *ngFor="let star of stars; let i = index" (click)="rate(i + 1)" (mouseenter)="hover(i + 1)"
            (mouseleave)="hover(0)" class="star" [class.filled]="(hoveredRating || rating) > i">
            ★
          </span>
        </div>

        <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
          <button class="w-100" style="text-decoration: underline;background:none;border:none"
            (click)="cancelOrder()">
            Skip
          </button>

          <button class="w-100" (click)="submitFeedback(taskId); showReviewOverlay = false"
            style="background:#5ECDA7;padding:12px 16px;border-radius:8px;border:none">
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
